import React, { FC } from 'react';
import { Center, Stack } from '@fiverr-private/layout_components';
import { Avatar, AvatarImage } from '@fiverr-private/avatar';
import { Text } from '@fiverr-private/typography';
import { Loader } from '@fiverr-private/feedback';
import { IAdminInfoProps } from './types';

export const AdminInfo: FC<IAdminInfoProps> = ({ adminInfo }) => (
    <Stack
        alignItems="center"
        paddingTop="4"
        paddingRight="3"
        paddingBottom="4"
        paddingLeft="3"
        borderColor="grey_400"
        borderWidth="sm"
        borderRadius="md"
    >
        {adminInfo ? (
            <>
                <Avatar size="md" username={adminInfo?.name || adminInfo?.username || ''}>
                    <AvatarImage alt="image-docs" src={adminInfo?.imageUrl} />
                </Avatar>
                <Stack direction="column" gap="0">
                    <Text>{adminInfo?.name}</Text>
                    <Text color="bodySecondary">{adminInfo?.email}</Text>
                </Stack>
            </>
        ) : (
            <Center width="100%">
                <Loader />
            </Center>
        )}
    </Stack>
);
